import { SvgIcon, SvgIconProps } from "@mui/material";

export const CustomersFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28">
      <circle
        cx="14.583"
        cy="13.417"
        r="11.083"
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M17.784 10.097c.01.273.01.548 0 .82a3.204 3.204 0 0 1-3.2 3.09v0a3.204 3.204 0 0 1-3.202-3.09c-.01-.272-.01-.547 0-.82a3.204 3.204 0 0 1 3.201-3.09v0a3.204 3.204 0 0 1 3.201 3.09v0Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M9.325 18.674a12.395 12.395 0 0 1 10.5 0"
      />
    </svg>
  </SvgIcon>
);
